import React, { useState } from 'react';
import './EnrollForm.css';
import { FaArrowLeft } from 'react-icons/fa';
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';
const EnrollForm = ({ onClose }) => {
  const [name, setName] = useState('');
  const [gender, setGender] = useState('');
  const [qualification, setQualification] = useState('');
  const [phone, setPhone] = useState('');
  // const [otpSent, setOtpSent] = useState(false);
  // const [otp, setOtp] = useState('');
  // const [isOtpVerified, setIsOtpVerified] = useState(false);
  // const [otpError, setOtpError] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);


  const handleBack = () => {
    if (onClose) onClose();
  };

  // const handleGetOtp = () => {
  //   if (phone.length === 10) {
  //     fetch('https://kodez.robokalam.in/api/send-otp.php', {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({ phone })
  //     })
  //       .then(res => res.json())
  //       .then(data => {
  //         if (data.status === 'success') {
  //           setOtpSent(true);
  //           setOtp('');
  //           setIsOtpVerified(false);
  //           setOtpError('');
  //           setPhoneError('');
  //         } else {
  //           setPhoneError(data.message);
  //         }
  //       })
  //       .catch(() => setPhoneError('Server error. Try again.'));
  //   } else {
  //     setPhoneError('Please enter a valid 10-digit phone number');
  //   }
  // };


  // const handleVerify = () => {
  //   fetch('https://kodez.robokalam.in/api/verify-otp.php', {
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json' },
  //     body: JSON.stringify({ phone, otp })
  //   })
  //     .then(res => res.json())
  //     .then(data => {
  //       if (data.status === 'success') {
  //         setOtpError('');
  //         setIsOtpVerified(true);
  //       } else {
  //         setOtpError(data.message || 'OTP verification failed');
  //       }
  //     })
  //     .catch(() => setOtpError('Server error during verification'));
  // };


  const handleSubmit = (e) => {
    e.preventDefault();

    if (!name || !gender || !qualification || !phone || !email) {
      alert('Please fill in all required fields!');
      return;
    }

    if (!email.endsWith('@gmail.com')) {
      setEmailError('Please enter a valid email ending with @gmail.com');
      return;
    } else {
      setEmailError('');
    }

    if (phone.replace(/\D/g, '').length < 10) {
      setPhoneError('Please enter a valid 10-digit phone number');
      return; // ← this was missing!
    } else {
      setPhoneError('');
    }

    // if (!otpSent || !isOtpVerified) {
    //   setOtpError('Please verify your OTP before submitting');
    //   return;
    // }

    // ✅ Send data to backend
    fetch('https://kodez.robokalam.in/api/enroll.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name,
        gender,
        qualification,
        phone,
        email,
      }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.status === 'success') {
          setShowSuccess(true);
          setTimeout(() => {
            setShowSuccess(false);
            onClose?.();
          }, 3000);
        } else {
          alert(data.message || 'Submission failed');
        }
      })
      .catch(() => alert('Server error. Please try again.'));
  };

  return (
    <div
      className="enroll-overlay"
      onClick={(e) => {
        if (e.target.classList.contains('enroll-overlay')) onClose?.();
      }}
    >
      <div className="enroll-form-wrapper">
        <div className="enroll-form">
          <div className="back-arrow" onClick={handleBack}>
            <FaArrowLeft /> Back
          </div>

          <h2>Enroll Now</h2>

          <form onSubmit={handleSubmit}>
            <label>Name</label>
            <input
              type="text"
              placeholder="Enter your name"
              className="input-box"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
            />

            <label>Gender</label>
            <select
              className="input-box"
              required
              value={gender}
              onChange={(e) => setGender(e.target.value)}
            >
              <option value="">--Select--</option>
              <option>Female</option>
              <option>Male</option>
              <option>Prefer not to disclose</option>
            </select>

            <label>Study/Qualification</label>
            <select
              className="input-box"
              required
              value={qualification}
              onChange={(e) => setQualification(e.target.value)}
            >
              <option value="">--Select--</option>
              <option>12th / Intermediate</option>
              <option>Diploma</option>
              <option>UG - Ongoing</option>
              <option>UG - Completed</option>
              <option>PG - Ongoing</option>
              <option>PG - Completed</option>
            </select>

            <label>Contact Number</label>
            <PhoneInput
              country={'in'}
              value={phone}
              onChange={(phone) => setPhone(phone)}
              enableSearch={true}
              placeholder="XXXXXXXXXX"
              inputClass="custom-phone-input"
              buttonClass="custom-phone-button"
              containerClass="custom-phone-container"
              dropdownClass="custom-phone-dropdown"
            />
            {/* <button
                type="button"
                className="otp-btn"
                disabled={phone.length !== 10}
                onClick={handleGetOtp}
              >
                Get OTP
              </button> */}
            {phoneError && <div className="error-msg">{phoneError}</div>}

            {/* {otpSent && (
              <div className="otp-field">
                <input
                  type="text"
                  value={otp}
                  onChange={(e) => setOtp(digitsOnly(e.target.value, 6))}
                  placeholder="Enter OTP"
                  className="otp-input"
                  maxLength={6}
                />
                {isOtpVerified ? (
                  <button type="button" className="verify-btn verified" disabled>
                    Verified ✅
                  </button>
                ) : (
                  <button
                    type="button"
                    className="verify-btn"
                    disabled={otp.length !== 6}
                    onClick={handleVerify}
                  >
                    Verify
                  </button>
                )}
                {otpError && <div className="error-msg">{otpError}</div>}
              </div>
            )} */}

            <label>Email ID</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="abc@gmail.com"
              className="input-box"
              required
            />
            {emailError && <div className="error-msg">{emailError}</div>}

            <div className="terms">
              <input type="checkbox" id="agree" required />
              <label htmlFor="agree">
                By proceeding further, I agree to the&nbsp;
                <a href="/terms-of-use" target="_blank" rel="noreferrer">Terms &amp; Conditions</a> and&nbsp;
                <a href="/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a> of KodeZ
              </label>
            </div>

            <button type="submit" className="submit-btn">
              Submit
            </button>
          </form>
        </div>
      </div>

      {showSuccess && (
        <div className="success-popup">
          🎉 You have successfully submitted the form!
        </div>
      )}
    </div>
  );
};

export default EnrollForm;
